<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:absolute,top:0,bottom:0,overflow:tShow?'hidden':'auto'}">
                    <div class="blk1">
                        <img src="./image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">故障报修</div>
                            <div class="txtku2">硬件报修</div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="mainSty" v-if="itemList.tOpen==1">
                                <div class="blkn">
                                    <div class="txt1">{{itemList.hardwareName}}</div>
                                </div>
                                <div class="blkn">
                                    <div class="txt2">{{itemList.hardwareCode}}</div>
                                </div>
                                <div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产类型</div>
                                            <div class="txt12">{{itemList.hardwareType}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产品牌</div>
                                            <div class="txt12">{{itemList.hardwareBrand}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产型号</div>
                                            <div class="txt12">{{itemList.serial}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">保修状态</div>
                                            <div class="txt12">{{itemList.maintainStatus}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产状态</div>
                                            <div class="txt12">{{itemList.hardwareStatus}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产3d位置</div>
                                            <div class="txt12">{{itemList.assets3dAddress}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;">
                                        <div class="btn1" @click="toSubmit(itemList.hardwareCode,itemList.hardwareId,itemList.hardwareName,itemList.dutyBy)">工单申报</div>
                                    </div>
                                    <div style="display:flex;justify-content:center;flex:1;" @click="toDetail(itemList.hardwareCode,itemList.hardwareId,itemList.hardwareName)">
                                        <div class="btn2">维修记录</div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;">
                                        <div class="btn16" @click="toOpen(itemList)">
                                            <van-icon name="arrow-down" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mainSty1" v-if="itemList.tOpen==2">
                                <div class="blkn">
                                    <div class="txt1">{{itemList.hardwareName}}</div>
                                </div>
                                <div class="blkn">
                                    <div class="txt2">{{itemList.hardwareCode}}</div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产类型</div>
                                        <div class="txt12">{{itemList.hardwareType}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产品牌</div>
                                        <div class="txt12">{{itemList.hardwareBrand}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产型号</div>
                                        <div class="txt12">{{itemList.version}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产序列号</div>
                                        <div class="txt12">{{itemList.serial}}</div>
                                    </div>
                                </div>
                                <!-- <div class="blkt">
							            <div style="display:flex">
							                <div class="txt11">MAC地址</div>
							                <div class="txt12">{{itemList.macAddress}}</div>
							            </div>
							        </div> -->
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产价值（元）</div>
                                        <div class="txt12">{{itemList.value}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">生产厂家</div>
                                        <div class="txt12">{{itemList.manufacturer}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">购入日期</div>
                                        <div class="txt12">{{itemList.buyDate}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修状态</div>
                                        <div class="txt12">{{itemList.maintainStatus}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修开始日期</div>
                                        <div class="txt12">{{itemList.maintainStart}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修结束日期</div>
                                        <div class="txt12">{{itemList.maintainFinish}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产状态</div>
                                        <div class="txt12">{{itemList.hardwareStatus}}</div>
                                    </div>
                                </div>

                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产3d位置</div>
                                        <div class="txt12">{{itemList.assets3dAddress}}</div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;">
                                        <div class="btn1" @click="toSubmit(itemList.hardwareCode,itemList.hardwareId,itemList.hardwareName,itemList.dutyBy)">工单申报</div>
                                    </div>
                                    <div style="display:flex;justify-content:center;flex:1;" @click="toDetail(itemList.hardwareCode,itemList.hardwareId,itemList.hardwareName)">
                                        <div class="btn2">维修记录</div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;">
                                        <div class="btn16" @click="toClose(itemList)">
                                            <van-icon name="arrow-up" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bindIp" v-if="itemList.softwareList.length>0">关联资产</div>
                        <div class="mainSty3" v-for="(item,index) in itemList.softwareList" :key="index">
                            <div class="blkn">
                                <div class="txt1">{{item.softwareName}}</div>
                            </div>
                            <div class="blkn">
                                <div class="txt2">{{item.softwareCode}}</div>
                            </div>
                            <div>
                                <div class="blkt">
                                    <div style="display:flex;width:100%;height:100%">
                                        <div class="txt11">资产类型</div>
                                        <div class="txt12">{{item.softwareType}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex;width:100%;height:100%">
                                        <div class="txt11">保修状态</div>
                                        <div class="txt12">{{item.maintainStatus==1?'在保':'过保'}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex;width:100%;height:100%">
                                        <div class="txt11">资产状态</div>
                                        <div class="txt12">{{item.softwareStatus}}</div>
                                    </div>
                                </div>
                                <!-- <div class="blkt">
										    <div style="display:flex;width:100%;height:100%">
										        <div class="txt11">访问IP</div>
										        <div class="txt12">{{item.osIp}}</div>
										    </div>
										</div> -->
                            </div>
                            <div class="blk2">
                                <div style="display:flex;justify-content:center;flex:1;" @click="toDetail(item.softwareCode,item.softwareId,item.softwareName)">
                                    <div class="btn2">维修记录</div>
                                </div>
                            </div>
                        </div>
                        <div class="bindIp" v-if="itemList.ip.length>0">绑定IP</div>
                        <div class="mainSty4" :key="index">
                            <div>
                                <div class="blkt" v-for="(item,index) in itemList.ip">
                                    <div style="display:flex;width:100%;height:100%">
                                        <div class="txt11">ip地址</div>
                                        <div class="txt12">{{item}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-if="tShow" style="position:absolute;left:0;top:0;bottom:0;width:100%;height:100%;">
                    <div class="mtblk" style="position:absolute;top:0;left:0;bottom:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
                        <div class="dialogs">
                            <img class="posImg" src="./image/x@2x.png" @click="submit"></img>
                            <div class="digtxt">您不是该设备的</div>
                            <div class="dts">管理员</div>
                            <div style="display:flex;align-items:center;justify-content:center">
                                <div class="submit" @click="submit">确定</div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <van-dialog v-model:show="tShow" @cancel="submit" @confirm="submit" confirm-button-color="#108EE9" show-cancel-button>
                    <div class="digtxt3">
                        <img src="../../components/image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                        <div style="padding: 20px 0; color: #003cff;text-align: center;">您不是该设备的<br>管理员</div>
                        <!-- <van-field v-model="reasons1" style="border:1px solid #eee" rows="3" autosize type="textarea" placeholder="请输入流转原因" /> -->
                    </div>
                </van-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import detailList from "@/components/detailList";
export default {
    components: { detailList },
    data() {
        return {
            title: "",
            code: "",
            tShow: false,
            itemList: {},
        };
    },
    methods: {
        toOpen(item) {
            item.tOpen = 2;
            this.$forceUpdate();
        },
        toClose(item) {
            item.tOpen = 1;
            this.$forceUpdate();
        },
        toDetail(code, id, name) {
            this.$router.push({
                path: "/capitalRecord",
                query: { code: code, id: id, froms: 0, name: name, type: 1 },
            });
        },
        toSubmit(code, id, name, dutyBy) {
            this.$router.push({
                path: "/declare",
                query: {
                    code: code,
                    id: id,
                    froms: 0,
                    name: name,
                    dictId: this.$route.query.dictId,
                    dutyBy: dutyBy,
                    responseType: 1,
                },
            });
        },
        submit() {
            this.$router.push("/index");
        },
        getData() {
            let data = { hardwareId: this.$route.query.id };
            this.$api
                .get("/app/corporateassets/getHardwareAssetsById", {
                    params: data,
                })
                .then((res) => {
                    if (res.data.code == "0000") {
                        let item = res.data.data;
                        item.maintainStatus =
                            item.maintainStatus == "1" ? "在保" : "过保";
                        if (item.hardwareStatus == 1) {
                            item.hardwareStatus = "使用";
                        } else if (item.hardwareStatus == 2) {
                            item.hardwareStatus = "维修";
                        } else if (item.hardwareStatus == 3) {
                            item.hardwareStatus = "报废";
                        }
                        item.tOpen = 1;
                        item.softwareList.forEach((item1) => {
                            if (item1.softwareStatus == 1) {
                                item1.softwareStatus = "使用";
                            } else if (item1.softwareStatus == 2) {
                                item1.softwareStatus = "维护";
                            } else if (item1.softwareStatus == 3) {
                                item1.softwareStatus = "停用";
                            }
                        });
                        this.itemList = item;
                    }
                });
        },
    },
    created() {
        if (this.$store.state.user.userInfo.role == 0) {
            if (this.$route.query.dutyBy) {
                if (
                    this.$route.query.dutyBy ==
                    this.$store.state.user.userInfo.userId
                ) {
                    this.tShow = false;
                } else {
                    this.tShow = true;
                }
            } else {
                this.tShow = false;
            }
        } else {
            this.tShow = false;
        }
        this.title = this.$route.query.tit;
        this.code = this.$route.query.code;
        this.getData();
    },
    mounted() {
        this.title = this.$route.query.tit;
        this.code = this.$route.query.code;
        this.getData();
    },
    watch: {
        itemList() {
            return this.itemList;
        },
    },
};
</script>
<style scoped>
.wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3000;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 20px;
}
.mainlist {
    position: absolute;
    width: 100%;
    height: 100%;
}
.bindIp {
    width: 335px;
    padding: 0px 21px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    color: #333333;
}
.mainSty {
    width: 303px;
    height: 400px;
    padding: 14px 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
}
.mainSty1 {
    width: 303px;
    height: 650px;
    padding: 14px 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
}
.mainSty3 {
    width: 303px;
    height: 280px;
    padding: 14px 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
}
.mainSty4 {
    width: 335px;
    height: 280px;
    padding: 14px 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    /* box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16); */
    /* background:#fff; */
    margin-bottom: 20px;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
    margin-bottom: 5px;
}
.dts {
    margin: 0 auto;
    width: 200px;
    height: 28px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
    margin-bottom: 25px;
}
.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 179px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.posImg {
    position: absolute;
    top: 10px;
    right: 10px;
}
.blk1 {
    position: relative;
    width: 100%;
    height: 148px;
}
.mtblk {
    width: 100%;
    height: 667px;
}
.txt1 {
    width: 290px;
    height: 28px;
    line-height: 28px;
    overflow: hidden;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 1;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}
.txt2 {
    width: 290px;
    height: 28px;
    line-height: 28px;
    overflow: hidden;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 1;
    font-size: 9px;
    font-weight: 400;
    color: #333333;
}

.blk2 {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
}
.btn1 {
    width: 136px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #0bbcb2 11%, #0bbc98 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.btn16 {
    width: 59px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    background: #8dc6ff;
    border-radius: 12px;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
}
.btn2 {
    width: 146px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.blkn {
    width: 290px;
    height: 28px;
    overflow: hidden;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
}
.blkps {
    position: absolute;
    top: 35px;
    right: 52px;
    width: 90px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.txtku2 {
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
}
.blkt {
    position: relative;
    margin: 0 auto;
    padding: 10px 13px;
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
}
.txt11 {
    overflow: hidden;
    　　text-overflow: ellipsis;
    　　white-space: wrap;
    flex: 0 0 100px;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    color: #666;
}
.txt12 {
    word-break: break-all;
    flex: 1;
    text-align: right;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
</style>
